import { type ClientContext, ContextClient } from '~/services/contextClient';
import type { ExtendedAxiosRequestConfig } from '~/services/BaseClient';
import WorkflowAnalyticsClientFactory from './workflowAnalyticsClient.factory';
import type {
    WorkflowAnalyticsClientInterface,
    WorkflowVersionParticipationParams,
    WorkflowVersionParticipationResponse,
} from './workflowAnalyticsClient.types';
import type { AxiosPromise } from 'axios';

class WorkflowAnalyticsClient extends ContextClient<WorkflowAnalyticsClientInterface> {
    constructor() {
        super(WorkflowAnalyticsClientFactory);
    }

    getWorkflowVersionParticipation(
        context: ClientContext,
        params: WorkflowVersionParticipationParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<WorkflowVersionParticipationResponse> {
        return this.getClient(context).getWorkflowVersionParticipation(params, config);
    }
}

export default new WorkflowAnalyticsClient();
